var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoSvgKurumsalCorporate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    width: "800px",
    height: "800px",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M640 455.1c0-33.8-13.4-64.4-34.9-87.3 11.6-16.9 30.9-27.9 52.9-27.9 35.4 0 64.1 28.7 64.1 64.1s-28.7 64.1-64.1 64.1c-6.7 0-13-1.3-19-3.2.3-3.2 1-6.4 1-9.8zm-128 89.6c49.5 0 89.6-40.1 89.6-89.6s-40.1-89.6-89.6-89.6-89.6 40.1-89.6 89.6 40.1 89.6 89.6 89.6zm0 54.7c-109.7 0-153.6 21.9-153.6 87.8v87.9h307.2v-87.9c0-66.3-43.9-87.8-153.6-87.8zm-116-91c-9.2-.6-19-1-30-1-78.5 0-110 15.7-110 62.8v76.9h69.4c16.7-57.8 70.4-76.7 120.5-83-21.8-13.2-39.2-32.5-49.9-55.7zm-30-40.2c6.7 0 13-1.3 19-3.2-.3-3.3-1-6.5-1-9.9 0-33.8 13.4-64.4 34.9-87.3-11.6-16.8-30.9-27.9-52.9-27.9-35.4 0-64.1 28.7-64.1 64.1s28.6 64.2 64.1 64.2zm292 39.1c-11 0-20.8.4-30 1.1-10.7 23.2-28.2 42.5-49.9 55.7 50.1 6.2 103.8 25.2 120.5 83H768v-76.9c0-47.5-31.4-62.9-110-62.9z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoSvgKurumsalCorporate);
export default __webpack_public_path__ + "static/media/ico_svg_kurumsal_corporate.28e8aa4e2071b4beca4bc87709a34be4.svg";
export { ForwardRef as ReactComponent };